import { StyledFlex, Text } from '@dreryk/react-components';

import { StyledStrongText } from './PatientInformationView.styled';
import { appointmentDateFormatter } from './PatientInformationView.utils';

type PatientInformationViewProps = {
   readonly patientFullName: string;
   readonly beginDate: Date;
   readonly endDate: Date;
};

export const PatientInformationView = (props: PatientInformationViewProps): JSX.Element => (
   <StyledFlex gap={4} direction={'column'}>
      <StyledStrongText testId={'patientFullName'}>{props.patientFullName}</StyledStrongText>
      <Text testId={'appointmentDate'}>{appointmentDateFormatter(props.beginDate, props.endDate)}</Text>
   </StyledFlex>
);
